import React, { useState } from 'react';
import { UploadIcon, FileTextIcon, TrashIcon } from 'lucide-react';
interface DocumentUploadButtonProps {
  fatturaId: string;
  documentiCaricati: boolean;
}
export function DocumentUploadButton({
  fatturaId,
  documentiCaricati
}: DocumentUploadButtonProps) {
  const [isUploading, setIsUploading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [uploadedDocs, setUploadedDocs] = useState(documentiCaricati);
  const handleUploadClick = () => {
    setShowModal(true);
  };
  const handleCloseModal = () => {
    setShowModal(false);
  };
  const simulateUpload = () => {
    setIsUploading(true);
    // Simuliamo un caricamento di 2 secondi
    setTimeout(() => {
      setIsUploading(false);
      setUploadedDocs(true);
      setShowModal(false);
    }, 2000);
  };
  const handleDeleteDocs = (e: React.MouseEvent) => {
    e.stopPropagation();
    setUploadedDocs(false);
  };
  return <>
      <button type="button" onClick={handleUploadClick} className={`inline-flex items-center px-3 py-1.5 border text-sm leading-4 font-medium rounded-md shadow-sm ${uploadedDocs ? 'text-green-700 bg-green-50 border-green-200 hover:bg-green-100' : 'text-gray-700 bg-white border-gray-300 hover:bg-gray-50'} focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500`} data-id="element-542">
        {uploadedDocs ? <>
            <FileTextIcon className="h-4 w-4 mr-2" data-id="element-543" />
            Documenti caricati
            <TrashIcon className="h-4 w-4 ml-2 text-red-500 hover:text-red-700" onClick={handleDeleteDocs} data-id="element-544" />
          </> : <>
            <UploadIcon className="h-4 w-4 mr-2" data-id="element-545" />
            Carica documenti
          </>}
      </button>
      {showModal && <div className="fixed z-10 inset-0 overflow-y-auto" data-id="element-546">
          <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0" data-id="element-547">
            <div className="fixed inset-0 transition-opacity" aria-hidden="true" data-id="element-548">
              <div className="absolute inset-0 bg-gray-500 opacity-75" data-id="element-549"></div>
            </div>
            <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true" data-id="element-550">
              &#8203;
            </span>
            <div className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full" data-id="element-551">
              <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4" data-id="element-552">
                <div className="sm:flex sm:items-start" data-id="element-553">
                  <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left w-full" data-id="element-554">
                    <h3 className="text-lg leading-6 font-medium text-gray-900" id="modal-title" data-id="element-555">
                      Carica documenti per la cessione
                    </h3>
                    <div className="mt-4 space-y-4" data-id="element-556">
                      <div data-id="element-557">
                        <label className="block text-sm font-medium text-gray-700" data-id="element-558">
                          Contratto di cessione
                        </label>
                        <div className="mt-1 flex justify-center px-6 pt-5 pb-6 border-2 border-gray-300 border-dashed rounded-md" data-id="element-559">
                          <div className="space-y-1 text-center" data-id="element-560">
                            <svg className="mx-auto h-12 w-12 text-gray-400" stroke="currentColor" fill="none" viewBox="0 0 48 48" aria-hidden="true" data-id="element-561">
                              <path d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" data-id="element-562" />
                            </svg>
                            <div className="flex text-sm text-gray-600" data-id="element-563">
                              <label htmlFor="file-upload-1" className="relative cursor-pointer bg-white rounded-md font-medium text-blue-600 hover:text-blue-500 focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-blue-500" data-id="element-564">
                                <span data-id="element-565">Carica un file</span>
                                <input id="file-upload-1" name="file-upload-1" type="file" className="sr-only" data-id="element-566" />
                              </label>
                              <p className="pl-1" data-id="element-567">o trascina e rilascia</p>
                            </div>
                            <p className="text-xs text-gray-500" data-id="element-568">
                              PDF fino a 10MB
                            </p>
                          </div>
                        </div>
                      </div>
                      <div data-id="element-569">
                        <label className="block text-sm font-medium text-gray-700" data-id="element-570">
                          Documentazione aggiuntiva
                        </label>
                        <div className="mt-1 flex justify-center px-6 pt-5 pb-6 border-2 border-gray-300 border-dashed rounded-md" data-id="element-571">
                          <div className="space-y-1 text-center" data-id="element-572">
                            <svg className="mx-auto h-12 w-12 text-gray-400" stroke="currentColor" fill="none" viewBox="0 0 48 48" aria-hidden="true" data-id="element-573">
                              <path d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" data-id="element-574" />
                            </svg>
                            <div className="flex text-sm text-gray-600" data-id="element-575">
                              <label htmlFor="file-upload-2" className="relative cursor-pointer bg-white rounded-md font-medium text-blue-600 hover:text-blue-500 focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-blue-500" data-id="element-576">
                                <span data-id="element-577">Carica un file</span>
                                <input id="file-upload-2" name="file-upload-2" type="file" className="sr-only" data-id="element-578" />
                              </label>
                              <p className="pl-1" data-id="element-579">o trascina e rilascia</p>
                            </div>
                            <p className="text-xs text-gray-500" data-id="element-580">
                              PDF, JPG, PNG fino a 10MB
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse" data-id="element-581">
                <button type="button" className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-600 text-base font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:ml-3 sm:w-auto sm:text-sm" onClick={simulateUpload} disabled={isUploading} data-id="element-582">
                  {isUploading ? 'Caricamento...' : 'Carica'}
                </button>
                <button type="button" className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm" onClick={handleCloseModal} data-id="element-583">
                  Annulla
                </button>
              </div>
            </div>
          </div>
        </div>}
    </>;
}